import { lazy } from 'react';

const DirectDebitContent = import(
  'components/direct-sales/direct-debit-revamp/components/DirectDebitContent'
);
const DirectDebitSidebarRight = import(
  'components/direct-sales/direct-debit-revamp/components/DirectDebitSidebarRight'
);
const DirectDebitHeader = import(
  'components/direct-sales/direct-debit-revamp/components/DirectDebitHeader'
);
const DirectDebitFooter = import(
  'components/direct-sales/direct-debit-revamp/components/DirectDebitFooter'
);

export const DirectDebit = {
  Content: lazy(() => DirectDebitContent),
  RightSidebar: lazy(() => DirectDebitSidebarRight),
  Header: lazy(() => DirectDebitHeader),
  Footer: lazy(() => DirectDebitFooter)
};

export default DirectDebit;
